import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { sendGetRequest, sendPatchRequest } from '../../../api/requestUtil';

export const toggleUpvoteComment = createAsyncThunk(
  'commentUpvote/toggle',
  async (
    {
      contentId,
      discussionId,
      commentId,
      contentType, // 💡 ADDED: Destructure the new property
    }: {
      contentId: number;
      discussionId: number;
      commentId: number;
      contentType: 'blog' | 'article' | 'clearing';
    },
    { getState }
  ) => {
    const state = getState() as AppState;
    const token = state.user.authToken;
    // Use the new contentType to build the dynamic base path
    const basePath = contentType === 'article' ? 'articles' : contentType === 'clearing' ? 'clearings' : 'blogs';

    try {
      const response = await sendPatchRequest(
        // Use the dynamic path
        `/api/${basePath}/${contentId}/discussions/${discussionId}/comments/${commentId}/upvote-comment/`,
        {},
        token
      );

      return {
        commentId,
        data: response,
        contentId,
        discussionId,
        total_upvotes: response.total_upvotes,
        user_has_upvoted: response.user_has_upvoted,
      };
    } catch (error) {
      throw new Error('Failed to toggle comment upvote');
    }
  }
);

export const fetchCommentUpvoteStatus = createAsyncThunk(
  'commentUpvote/fetchStatus',
  async (
    // 1. Destructure the new property
    {
      contentId,
      discussionId,
      commentId,
      contentType,
    }: {
      // 2. Define the new property in the type signature
      contentId: number;
      discussionId: number;
      commentId: number;
      contentType: 'blog' | 'article' | 'clearing';
    },
    { getState }
  ): Promise<{ commentId: number; data: CommentUpvoteStatus }> => {
    const state = getState() as AppState;
    const token = state.user.authToken || null;

    if (!contentId || !discussionId || !commentId || !contentType) {
      throw new Error(
        'Missing required parameters for comment upvote status fetch'
      );
    }

    // Use contentType to build the URL (ensuring URL is also updated)
    const basePath = contentType === 'article' ? 'articles' : contentType === 'clearing' ? 'clearings' : 'blogs';

    const response = await sendGetRequest(
      `/api/${basePath}/${contentId}/discussions/${discussionId}/comments/${commentId}/upvote-status-comment/`,
      token
    );

    return {
      commentId,
      data: {
        contentId,
        discussionId,
        commentId,
        total_upvotes: response.total_upvotes,
        user_has_upvoted: response.user_has_upvoted,
        loading: false,
        error: null,
      },
    };
  }
);

export const resetCommentUpvotes = createAction('comment-upvotes/reset');
